import { createSlice } from "@reduxjs/toolkit";

export const querySlice = createSlice({
  name: "queryText",
  initialState: {
    value: "",
    startDate: 0,
    endDate: 0,
    storylineStartDate: 0,
    storylineEndDate: 0,
    loading: false,
    fromStorylines: false,
    storylineChatId: "",
    queryType: "",
    resetQuery: false,
    progressMessage: "",
  },
  reducers: {
    updateQuery: (state, action) => {
      state.value = action.payload;
    },
    updateQueryStartDate: (state, action) => {
      state.startDate = action.payload;
    },
    updateQueryEndDate: (state, action) => {
      state.endDate = action.payload;
    },
    updateStorylineStartDate: (state, action) => {
      state.storylineStartDate = action.payload;
    },
    updateStorylineEndDate: (state, action) => {
      state.storylineEndDate = action.payload;
    },
    updateFromStorylines: (state, action) => {
      state.fromStorylines = action.payload;
    },
    updateLoading: (state, action) => {
      state.loading = action.payload;
    },
    updateStorylineChatId: (state, action) => {
      state.storylineChatId = action.payload;
    },
    updateQueryType: (state, action) => {
      state.queryType = action.payload;
    },
    resetQuery: (state, action) => {
      state.resetQuery = action.payload;
    },
    updateProgressMessage: (state, action) => {
      state.progressMessage = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  updateQuery,
  updateQueryStartDate,
  updateQueryEndDate,
  updateStorylineStartDate,
  updateStorylineEndDate,
  updateFromStorylines,
  updateLoading,
  updateStorylineChatId,
  updateQueryType,
  resetQuery,
  updateProgressMessage,
} = querySlice.actions;

export default querySlice.reducer;
